(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wow-corporate-gifting"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const buttons = [...root.querySelectorAll('[data-filter]')];
    const cards = [...root.querySelectorAll('[data-occasions]')];
    const select = root.querySelector('[data-gift-select]');
    const quantity = root.querySelector('[data-gift-quantity]');
    const occasionSelect = root.querySelector('[data-gift-occasion]');
    const total = root.querySelector('[data-gift-total]');
    const status = root.querySelector('[data-filter-status]');
    const money = value => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency || 'EUR'}).format(value / 100);
    const updateTotal = () => {if(select?.selectedOptions[0] && total) total.textContent = money(Number(select.selectedOptions[0].dataset.price) * Math.max(1, Number(quantity.value) || 1));};
    const setOccasion = value => {
      if (!buttons.some(button => button.dataset.filter === value)) value = 'all';
      buttons.forEach(button => {const active = button.dataset.filter === value;button.classList.toggle('is-active', active);button.setAttribute('aria-pressed', String(active));});
      cards.forEach(card => {card.hidden = value !== 'all' && !card.dataset.occasions.split(',').includes(value);});
      if (status) {const active = buttons.find(button => button.dataset.filter === value);status.textContent = active ? active.textContent.trim() : '';}
      const option = [...(occasionSelect?.options || [])].find(option => option.dataset.occasion === value);
      if (option) occasionSelect.value = option.value;
    };
    buttons.forEach(button => button.addEventListener('click', () => setOccasion(button.dataset.filter)));
    root.querySelectorAll('[data-occasion-link]').forEach(link => link.addEventListener('click', () => setOccasion(link.dataset.occasionLink)));
    root.querySelectorAll('[data-select-gift]').forEach(link => link.addEventListener('click', () => {if([...select.options].some(option => option.value === link.dataset.selectGift)){select.value = link.dataset.selectGift;updateTotal();select.focus({preventScroll:true});}}));
    root.querySelectorAll('[data-enquire-gift]').forEach(link => link.addEventListener('click', () => {const input = root.querySelector('[data-enquiry-gift]');if(input){input.value = link.dataset.enquireGift;input.focus({preventScroll:true});}}));
    select?.addEventListener('change', updateTotal);quantity?.addEventListener('input', updateTotal);updateTotal();
    const params = new URLSearchParams(window.location.search);if(params.has('occasion')) setOccasion(params.get('occasion'));
    root.querySelector('.wow-gift-order-form')?.addEventListener('submit', async event => {
      const form = event.currentTarget;
      if (!window.fetch || !form.reportValidity()) return;
      event.preventDefault();
      const button = form.querySelector('[data-add-gift]');const error = form.querySelector('[data-cart-error]');button.disabled = true;button.setAttribute('aria-busy','true');error.hidden = true;
      try {
        const response = await fetch(root.dataset.cartAddUrl, {method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || error.textContent);
        window.location.assign(root.dataset.cartUrl);
      } catch (problem) {error.textContent = problem.message;error.hidden = false;button.disabled = false;button.removeAttribute('aria-busy');}
    });
  };
  document.querySelectorAll('[data-wow-gifting]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wow-gifting]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wow-gifting-range"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('.wow-range-order').forEach(form => {
      const variant = form.querySelector('[data-range-variant]');
      const quantity = form.querySelector('[data-range-quantity]');
      const total = form.querySelector('[data-range-total]');
      const update = () => {total.textContent = new Intl.NumberFormat(root.dataset.locale || 'en',{style:'currency',currency:root.dataset.currency || 'EUR'}).format(Number(variant.selectedOptions[0].dataset.price) * Math.max(1, Number(quantity.value) || 1) / 100);};
      variant.addEventListener('change',update);quantity.addEventListener('input',update);update();
      form.addEventListener('submit',async event => {
        if (!window.fetch || !form.reportValidity()) return;
        event.preventDefault();
        const button = form.querySelector('button[type=submit]');const error = form.querySelector('.wow-range-error');
        button.disabled = true;button.setAttribute('aria-busy','true');error.hidden = true;
        try {
          const response = await fetch(root.dataset.cartAddUrl,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || error.textContent);
          window.location.assign(root.dataset.cartUrl);
        } catch(problem) {error.textContent = problem.message;error.hidden = false;button.disabled = false;button.removeAttribute('aria-busy');}
      });
    });
  };
  document.querySelectorAll('[data-wow-range]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-wow-range]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
